import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { statBarHeight } from '~/utilities';

interface GridContainerProps {
  hasGround: boolean;
}

export const StatStyled = styled(Box).attrs({
  pt: { sm: '300' },
  pl: { sm: '450' },
  pb: { sm: '300' },
})`
  height: ${statBarHeight}px;
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.grey[100]};
  `}
`;

export const GridContainerStyled = styled.div<GridContainerProps>`
  display: grid;
  ${({ theme, hasGround }) => css`
    grid-template-columns: ${!hasGround && `repeat(2, 1fr)`};
    grid-template-rows: ${hasGround && `repeat(2, 1fr)`};
    min-width: ${hasGround ? `145px` : `300px`};
    padding-top: ${theme.spacings[300]};
    padding-bottom: ${theme.spacings[300]};
    grid-column-gap: ${theme.spacings[400]};
    margin-left: ${theme.spacings[400]};
    align-items: center;
  `}
`;
export const TagStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    font-size: ${theme.fontSizes[100]};
    border-radius: ${theme.radii[200]};
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    height: 100%;
    width: 16px;
  `}
`;

export const AllZeroDoghnutStyled = styled(Box).attrs({})`
  ${({ theme }) => css`
    width: 60px;
    height: 60px;
    border-radius: ${theme.radii[900]};
    border: 12px solid ${theme.colors.grey[200]};
  `}
`;

export const DoughnutTagContainer = styled(Box).attrs({
  mr: { sm: '300' },
  ml: { sm: '500' },
})`
  width: 16px;
`;
